import lazyWithRetry from 'tools/lazyWithRetry';

const TaskOperationArticleAvailableListPage = lazyWithRetry(() => import(
	/* webpackChunkName: "TaskOperationArticleAvailableListPage" */
	'../../../pages/TaskOperationArticle/TaskOperationArticleAvailableListPage'));

const TaskOperationArticleWaitingListPage = lazyWithRetry(() => import(
	/* webpackChunkName: "TaskOperationArticleWaitingListPage" */
	'../../../pages/TaskOperationArticle/TaskOperationArticleWaitingListPage'));

export default [
	{
		component: TaskOperationArticleAvailableListPage,
		exact: true,
		path: '/sub_partitions/:subPartitionId/available_task_operation_articles',
	},
	{
		component: TaskOperationArticleWaitingListPage,
		exact: true,
		path: '/sub_partitions/:subPartitionId/waiting_task_operation_articles',
	},
];